import Text from '@skapa/Text';
import useTranslations from 'context/Translations';
import React from 'react';
import styles from './ListThumbnailMissingImage.module.scss';

const ListThumbnailMissingImage = () => {
    const translate = useTranslations();

    return (
        <div className={styles.wrapper}>
            <Text textStyle="Body.M" tagName="span">
                {translate('LISTOVERVIEW_LISTS_THUMBNAIL_EMPTY')}
            </Text>
        </div>
    );
};

export default ListThumbnailMissingImage;
